export const AutoSyncCasesDataLayerSymbol = Symbol.for("AutoSyncCasesDataLayerSymbol");
